var map = {
	"./amazon.store.js": 950,
	"./base2.store.js": 8426,
	"./common.store.js": 6420,
	"./dashboard.store.js": 2362,
	"./issue-comments.store.js": 6593,
	"./issue2.store.js": 7296,
	"./notification.store.js": 4986,
	"./purchasedItem.store.js": 3694,
	"./session.store.js": 9854,
	"./user.store.js": 2312
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8928;